export default __webpack_public_path__ + "static/media/flag-ee.fc0d0195.svg";